export class ClickStatistics {
  public Url: string = '';
  public UniqueClick: number = 0;
  public ClickedTotal: number = 0;

  // used in typescript, not in api
  public clickPercent: number = 0;
}
